export const DEPOSIT_WITHDRAWAL_CONTAINER = 'DEPOSIT_WITHDRAWAL_CONTAINER';
export const VERTICAL_NAV_CONTAINER = 'VERTICAL_NAV_CONTAINER';
export const ORDER_ENTRY_CONTAINER = 'ORDER_ENTRY_CONTAINER';
